import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Returns.frontend.types'

@Injectable({ providedIn: 'root' })
export class Returns_create_licenseplate_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { properties: any }): Promise<{ reasons?: string[], licenseplateId?: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.properties)) {
      missingRequiredInParams.push('\'properties\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/functions/create_licenseplate_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

